var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ColumnBaseComponent } from '../../items/columns/base/columnbase.component';
import { ColumnService } from '../../items/columns/column/column.service';
import { ColumnBaseService } from '../../items/columns/base/columnbase.service';
import { ApiService } from '../../service/api.service';
var ItemSubItemSelect2Component = /** @class */ (function (_super) {
    __extends(ItemSubItemSelect2Component, _super);
    function ItemSubItemSelect2Component(service, baseService, apiService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.apiService = apiService;
        _this.changeSelect = new EventEmitter();
        return _this;
    }
    ItemSubItemSelect2Component.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ItemSubItemSelect2Component.prototype.ngAfterViewInit = function () {
        this.url = this.apiService.makeUrl('/v1/gen/ec-item-m-price-view-api');
        this.element = this.select2Element.nativeElement;
        var self = this;
        $(this.element).select2({
            data: [{ id: this.val, text: this.val }],
            width: '100%',
            ajax: {
                delay: 300,
                dataType: 'json',
                url: this.url,
                xhrFields: { withCredentials: true },
                data: function (params) {
                    var q = {
                        predicateList: [
                            { operator: 'in', name: 'item_type', values: [1, 2] },
                            { operator: 'like', name: 'item_no', value: params.term }
                        ],
                        orderByList: [{ name: 'item_no', direction: 'asc' }],
                        limit: 10,
                        offset: params.page ? (params.page - 1) * 10 : 0,
                    };
                    var query = {
                        query: JSON.stringify(q),
                        page: params.page
                    };
                    return query;
                },
                processResults: function (data, params) {
                    var options = [];
                    for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                        var item = _a[_i];
                        options.push({
                            id: item.item_no,
                            text: item.item_no + ' ' + item.item_name,
                            item_id: item.item_id,
                            item_no: item.item_no,
                            item_name: item.item_name,
                            price: item.price
                        });
                    }
                    params.page = params.page || 1;
                    return {
                        results: options,
                        pagination: {
                            more: (params.page * 10) < data.totalRowCount
                        }
                    };
                },
                transport: function (params, success, failure) {
                    var $success = function (data, textStatus, jqXHR) {
                        self.apiService.checkBuildNoStr(jqXHR.getResponseHeader('x-pg-spa-buildno'));
                        success(data);
                    };
                    var $failure = function (jqXHR) {
                        var checkBuildNo = self.apiService.checkBuildNoStr(jqXHR.getResponseHeader('x-pg-spa-buildno'));
                        if (checkBuildNo && jqXHR.status === 401) {
                            $(self.element).select2('close');
                            self.apiService.onUnauthorized(jqXHR.responseJSON);
                        }
                        failure();
                    };
                    var $request = $.ajax(params);
                    $request.then($success);
                    $request.fail($failure);
                    return $request;
                }
            },
            minimumInputLength: 1,
            templateSelection: this.formatRepoSelection
        });
        $(this.element).on('select2:select', function (e) {
            var data;
            if (e['params'] && e['params']['data']) {
                data = e['params']['data'];
                self.val = data.id;
            }
            self.onChange(self.val);
            self.onChangeSelect(data);
        });
        $(this.element).val(this.val).trigger('change');
    };
    ItemSubItemSelect2Component.prototype.formatRepoSelection = function (repo) {
        return repo.id || repo.text;
    };
    ItemSubItemSelect2Component.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        if (changes.val && !changes.val.firstChange) {
            $(this.element).select2('destroy');
            this.ngAfterViewInit();
        }
    };
    ItemSubItemSelect2Component.prototype.onChange = function (e) {
        _super.prototype.onChange.call(this, e);
    };
    ItemSubItemSelect2Component.prototype.onChangeSelect = function (e) {
        this.changeSelect.emit({ key: this.col.key, val: e });
    };
    ItemSubItemSelect2Component.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'item-subitem-select2',
                    template: "\n        <select name=\"{{ col.key }}\" attr.name=\"{{ col.key }}\" [(ngModel)]=\"val\" [key]=\"key\" [col]=\"col\" columnDir #s2>\n        </select>\n    "
                }] }
    ];
    /** @nocollapse */
    ItemSubItemSelect2Component.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ApiService }
    ]; };
    ItemSubItemSelect2Component.propDecorators = {
        changeSelect: [{ type: Output }],
        select2Element: [{ type: ViewChild, args: ['s2',] }]
    };
    return ItemSubItemSelect2Component;
}(ColumnBaseComponent));
export { ItemSubItemSelect2Component };
//# sourceMappingURL=item-subitem-select2.component.js.map